/* ------------------------------------------------------------------
   EMIR — Panneau latéral produit  ·  v2
   Correctif d'ouverture : le contenu apparaissait parfois tronqué en haut
   ou en bas. Trois causes, toutes traitées ici :
     1. le verrou de défilement (position:fixed sur body) reflowait la page
        pendant la transition -> on force un reflow et on attend deux frames
        avant de lancer l'animation ;
     2. le corps du panneau gardait sa position de défilement d'une ouverture
        à l'autre -> on remet scrollTop à 0 à chaque ouverture ;
     3. le focus était posé sur la zone scrollable, ce qui la faisait défiler
        toute seule -> le focus va sur le bouton de fermeture.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input, select, details, [tabindex]:not([tabindex="-1"])';

  var scrollY = 0;
  var openCount = 0;

  function lockScroll() {
    if (openCount === 0) {
      scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('emir-panel-locked');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    openCount++;
  }

  function unlockScroll() {
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) {
      document.body.classList.remove('emir-panel-locked');
      ['position', 'top', 'left', 'right', 'width'].forEach(function (p) {
        document.body.style.removeProperty(p);
      });
      window.scrollTo(0, scrollY);
    }
  }

  if (!customElements.get('emir-panel')) {
    customElements.define(
      'emir-panel',
      class EmirPanel extends HTMLElement {
        constructor() {
          super();
          this.isOpen = false;
          this.opener = null;
          this._onKeydown = this._onKeydown.bind(this);
        }

        connectedCallback() {
          var self = this;

          // Un ancetre porte souvent un transform (ici la classe .reveal du
          // theme EMIR). Un element transforme devient le referentiel des
          // enfants en position:fixed : le panneau se calait alors sur la
          // section et non sur la fenetre — d'ou une hauteur fausse qui
          // variait selon le defilement. On le deplace donc a la racine du
          // document, ou plus aucun transform ne peut le contraindre.
          if (this.parentElement && this.parentElement !== document.body) {
            var twin = document.getElementById(this.id);
            if (twin && twin !== this && twin.parentElement === document.body) {
              twin.parentElement.removeChild(twin);
            }
            document.body.appendChild(this);
            return; // connectedCallback est rappele apres le deplacement
          }
          if (this._wired) return;
          this._wired = true;
          this.querySelectorAll('[data-emir-panel-close]').forEach(function (el) {
            el.addEventListener('click', function (event) {
              event.preventDefault();
              self.close();
            });
          });
        }

        open(opener) {
          if (this.isOpen) return;
          this.isOpen = true;
          this.opener = opener || null;

          lockScroll();
          this.hidden = false;

          var body = this.querySelector('[data-emir-panel-body]');
          if (body) body.scrollTop = 0;

          // force le calcul de la mise en page avant d'animer, puis attend
          // deux frames : la feuille a alors sa hauteur définitive.
          void this.offsetHeight;
          var self = this;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              self.classList.add('is-open');
              if (body) body.scrollTop = 0;
            });
          });

          if (this.opener) this.opener.setAttribute('aria-expanded', 'true');
          document.addEventListener('keydown', this._onKeydown);

          var closeBtn = this.querySelector('.emir-panel__close');
          if (closeBtn) closeBtn.focus({ preventScroll: true });

          this.dispatchEvent(new CustomEvent('emir-panel:open', { bubbles: true }));
        }

        close() {
          if (!this.isOpen) return;
          this.isOpen = false;

          this.classList.remove('is-open');
          document.removeEventListener('keydown', this._onKeydown);

          var self = this;
          var sheet = this.querySelector('.emir-panel__sheet');
          var done = false;
          var finish = function () {
            if (done) return;
            done = true;
            if (sheet) sheet.removeEventListener('transitionend', finish);
            self.hidden = true;
          };

          if (sheet && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
            sheet.addEventListener('transitionend', finish);
            setTimeout(finish, 520);
          } else {
            finish();
          }

          unlockScroll();

          if (this.opener) {
            this.opener.setAttribute('aria-expanded', 'false');
            this.opener.focus({ preventScroll: true });
          }

          this.dispatchEvent(new CustomEvent('emir-panel:close', { bubbles: true }));
        }

        _onKeydown(event) {
          if (event.key === 'Escape' || event.key === 'Esc') {
            event.stopPropagation();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;

          var nodes = Array.prototype.filter.call(
            this.querySelectorAll(FOCUSABLE),
            function (el) { return el.offsetParent !== null || el === document.activeElement; }
          );
          if (!nodes.length) return;

          var first = nodes[0];
          var last = nodes[nodes.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
    );
  }

  // Délégation : survit à un re-render de section (changement de variante…)
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-emir-panel-open]');
    if (!trigger) return;

    var panel = document.getElementById(trigger.getAttribute('data-emir-panel-open'));
    if (!panel || typeof panel.open !== 'function') return;

    event.preventDefault();
    panel.open(trigger);
  });
})();